module.exports = __webpack_public_path__ + "img/img2-3.30771239.png";